import CheckIcon from '@mui/icons-material/CheckRounded';
import { Typography } from '@mui/material';

interface CompanySealedProps {
  companyName: string;
}

/**
 * The moment a company goes clear.
 *
 * A director walking a long queue gets no sense of arrival: step 12 of 32 feels
 * exactly like step 11. But finishing a *company* is a real milestone — it is
 * the unit they are actually responsible for — so it is marked rather than
 * passed over silently.
 *
 * Shown between chapters, above whatever the next company's first step is, and
 * only when the company sealed with nothing skipped. It states the fact and
 * gets out of the way; the rail above keeps the seal permanently.
 */
export const CompanySealed = ({ companyName }: CompanySealedProps) => (
  <div
    className="flex items-center gap-2.5 rounded-lg bg-success/8 px-3 py-2 inset-ring inset-ring-success/20 motion-safe:animate-seal"
    role="status"
  >
    <span
      aria-hidden
      className="flex size-5 shrink-0 items-center justify-center rounded-full bg-success text-white [&>svg]:text-[14px]"
    >
      <CheckIcon fontSize="inherit" />
    </span>

    <Typography variant="body2" className="min-w-0">
      <span className="font-semibold text-success-dark">{companyName}</span>
      <span className="text-content-muted"> is all clear. Next company below.</span>
    </Typography>
  </div>
);
